<div class="banner d-none d-lg-flex" role="banner">
  <div class="container">
    <div class="title-wrapper">
      <img src="assets/images/banners/Worksheets.png" alt="" />
    </div>
  </div>
</div>
<fgb-mobile-header-bar [title]="'worksheet.page.title' | translate" [showPoints]="false"></fgb-mobile-header-bar>
<div class="mobile-content-wrapper">
  <div class="container">
    <fgb-worksheet-list></fgb-worksheet-list>
  </div>
</div>
